import { createUseQuery } from 'api/common/createUseQuery'
import { fetchPractitioners } from 'api/fetchers/fetchPractitioners'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { ApiResponse } from 'types/common/utils'
import { Practitioner } from 'types/practitioners'

export const usePractitioners = createUseQuery({
  queryKey: ApiQueryKeys.PRACTITIONERS,
  fetcher: fetchPractitioners,
  selector: res => res?.data as ApiResponse<Practitioner> | undefined,
})
